export const SLUG = "winter-solstice-retreat-galena-2026";
const F = "https://avianayoga.com/api/files";

export const DEFAULT_IMAGES = {
  hero: `${F}/b478456f-7c13-45c4-a54a-7c1a0d4b3b27`,
  opening: `${F}/116cfd3c-59e3-4e56-8905-261f5b3e30e4`,
  "fire-band": "https://images.unsplash.com/photo-1696860740767-f4211c9209f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  "who-for": "https://images.unsplash.com/photo-1706922122814-12402375d89a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "exp-rest": `${F}/627b1abc-25d9-44c2-abf1-dcea07cbd52e`,
  "exp-create": `${F}/aacdb55d-25b7-4464-8661-46fddfba9cf9`,
  "exp-ranch": `${F}/b5a4002a-d333-42f8-a25a-45cc00fe7228`,
  belonging: `${F}/670b7f22-3c54-42b2-ac53-c197f0227e5d`,
  "exp-galena": "https://images.unsplash.com/photo-1632665152039-8e19f6f79884?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  treasures: `${F}/997c25f0-e0c4-417e-b11b-fdecc4310c0a`,
  itinerary: `${F}/c31f1c80-5780-4132-bcb8-b64f7a977c5c`,
  "room-shared_king": `${F}/f17368a4-2904-45f9-b1b5-af0708d22a9d`,
  "room-private_king": `${F}/7100a266-93d3-46ec-956c-b5a25e352255`,
  "room-triple": `${F}/336822d0-ba64-402e-80bc-4017b10b6e2f`,
  "stay-bathroom": `${F}/4b8a4122-a0fa-4483-9edc-6d95c1d7d17d`,
  host: `${F}/09e5027b-e93e-41da-9960-e219f048dba3`,
  "closing-bg": "https://images.unsplash.com/photo-1575970141761-c1b3f1080955?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

export const OPENING = [
  "Imagine a cozy log cabin nestled among the rolling countryside of Galena, Illinois. A crackling fire, horses grazing in the pasture, the warmth of a hot tub beneath the winter sky and the welcoming embrace of sisterhood. For a few precious days, there is nowhere else you need to be.",
  "As the year draws to a close, join us for a beautiful Winter Solstice gathering devoted to slowing down, replenishing your spirit and reconnecting with yourself and one another. Honoring the longest night of the year and the beautiful return of the light, we'll create space to reflect, release what we've outgrown and welcome the possibilities of a new season.",
  "Immerse yourself in the grounding presence of horses, the creativity of crafting your own wooden cutting board, gentle movement, restorative yoga, aromatherapy, sound healing and sacred sisterhood rituals. Enjoy nourishing meals lovingly prepared by Holly, fireside conversations, laughter, creativity and moments of simply being.",
  "With an optional third night, there's even more time to wander the charming streets of Galena, explore the surrounding countryside, visit a local winery and gather once more around the fire for an evening of beeswax candle making.",
  "Come put down the weight of the world for a little while. Let nature ground you, let sisterhood nourish you and let the returning light remind you of all that is possible.",
];

export const OPENING_CLOSER = "Come as you are. Leave renewed, reconnected and carrying a little more light within.";

export const BOOKING_LINE = "Two nights of sisterhood, with the option to linger for three. Limited spaces.";

export const WHO_FOR = [
  "Mothers and daughters longing for sacred time together",
  "Dear friends ready to rest side by side before the holiday rush",
  "Women called to honor the solstice in ceremony and sisterhood",
  "Women coming on their own — you will arrive a guest and leave a sister",
];

export const EXPERIENCES = [
  { key: "exp-rest", title: "Rest & Rejuvenate", items: ["Opening Winter Solstice Sister Circle", "Restorative Yoga and Guided Relaxation", "Candle Meditation", "Aromatherapy Experience", "Sacred Sisterhood Salt Soak Creation", "Hot Tub and Fireside Relaxation", "Sister Sound Bath", "Sacred Solstice Meditation"] },
  { key: "exp-create", title: "Create & Connect", items: ["Hands-on Wooden Cutting Board Workshop led by the owner of the ranch", "Handmade Solstice Candle Creation (extended retreat)", "Aromatherapy Infused Salt Soak", "Beautiful Memories and Moments with the Horses"] },
  { key: "exp-ranch", title: "The Heart of the Ranch", items: ["Time with the Horses: Connection, Grooming and Quiet Presence", "Gentle Morning Movement", "Nourishing Chef-Prepared Meals by Holly", "Fireside Conversations and Sisterhood"] },
  { key: "exp-galena", title: "A Little More Galena", note: "Extended retreat", items: ["Optional Winery Visit", "Charming Downtown Galena Shops", "Local Waterfall Exploration", "An Extra Evening of Creativity, Connection and Relaxation"] },
];

export const TREASURES = [
  "Your own handcrafted wooden cutting board",
  "A sacred sisterhood salt soak",
  "A handmade candle (extended retreat guests)",
  "Photographs capturing your time with the horses",
  "A heart full of sisterhood, connection and memories",
];

export const ITINERARY = [
  { day: "Day 1 · Friday Evening", date: "December 18", intro: "An evening to settle in, exhale and reconnect.", blocks: [{ rows: [
    ["4:00–5:30 PM", "Arrival, room settling and welcome appetizers"],
    ["6:00 PM", "Chef-prepared welcome dinner"],
    ["7:00 PM", "Opening Winter Solstice Sister Circle"],
    ["7:45 PM", "Collective Sacred Sisterhood Salt Soak Creation"],
    ["8:15 PM", "Evening of Rejuvenation — restorative yoga, guided candle meditation, aromatherapy, relaxing fireside time, hot tub and quiet connection"],
    ["9:30 PM", "Tea, conversation and rest"],
  ] }] },
  { day: "Day 2 · Saturday", date: "December 19", intro: "A day of creativity, connection and the beautiful presence of horses.", blocks: [{ rows: [
    ["8:00 AM", "Nourishing breakfast"],
    ["9:00 AM", "Gentle Morning Movement"],
    ["9:45 AM", "Groups divide for morning experiences"],
    ["Group One", "The Art of Woodworking — visit the neighboring woodshop and craft a beautiful wooden cutting board to take home"],
    ["Group Two", "The Hearts of Horses — meet and connect with the horses, grooming and quiet time in their presence, horse photoshoot"],
    ["12:30 PM", "Nourishing ranch-style lunch"],
    ["1:30 PM", "Groups switch experiences"],
    ["4:30 PM", "Free time, hot tub and relaxation"],
    ["6:00 PM", "Chef-prepared dinner"],
    ["7:30 PM", "Cacao Gathering"],
    ["8:00 PM", "Sister Sound Bath and Sacred Meditation"],
    ["9:00 PM", "Fireside sisterhood and winding down"],
  ] }] },
  { day: "Day 3 · Sunday", date: "December 20", intro: "A gentle transition for those heading home, and a little more time for those who choose to stay.", blocks: [
    { label: "For all retreat participants", rows: [
      ["8:00 AM", "Fulfilling breakfast"],
      ["9:00 AM", "Closing Winter Solstice Sister Circle"],
      ["10:00 AM", "Farewells and departures for two-night guests"],
    ] },
    { label: "For extended-stay sisters", rows: [
      ["Late morning", "Explore Galena at your leisure — waterfall, downtown shops, optional winery, lunch on your own"],
      ["4:30 PM", "Return to the ranch and relax"],
      ["6:00 PM", "Chef-prepared dinner"],
      ["7:30 PM", "Beeswax Candle Making, fireside conversations, creativity and sisterhood"],
    ] },
  ] },
  { day: "Day 4 · Monday", date: "December 21 · Extended stay", intro: "One last morning to soak in the beauty of the ranch.", blocks: [{ rows: [
    ["8:00 AM", "Final nourishing breakfast"],
    ["9:00 AM", "Winter countryside walk and one last visit with the horses"],
    ["10:30 AM", "Departures and journeys home"],
  ] }] },
];
